<!--
 * @Author: 孙泽严 343362726@qq.com
 * @Date: 2022-01-10 11:16:37
 * @LastEditors: 孙泽严 343362726@qq.com
 * @LastEditTime: 2022-06-15 15:29:56
 * @FilePath: \cacaclo_front_end\src\views\commodity\components\Sort.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="sort p-r">
    <img src="@/assets/img/homePage/排序.png" style="height: 22px" class="sortIcon pointer">
    <span class="sort-by-text">{{$t('currency.sortBy')}}</span>
    <el-select v-model="sortKey" class="sort-select" @change="sortChange">
      <el-option v-for="item in sortOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
    </el-select>
  </div>
</template>

<script>
import getSortOptions from '@/config/sortOptions.js'
export default {
  data() {
    return {
      sortKey: undefined,
      sortOptions: getSortOptions.call(this)
    }
  },
  methods: {
    sortChange() {
      const sort = this.sortOptions.find(item => +item.key === +this.sortKey)
      this.$emit('change', sort.sortName, sort.sortType)
    },
    sortreset() {
      this.sortKey = undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.sort{
  display: inline-block;
  .sortIcon {
    position: absolute;
    top: 6px;
    left: 8px;
    z-index: 100;
  }
}
.sort-by-text{
  z-index: 1;
  position: absolute;
  top: 0px;
  left: 35px;
  color: #8B93A3;
  font-size: 14px;
  line-height: 34px;
}
.sort-select{
  /deep/.el-select,/deep/.el-input__inner{
    width: 230px;
    height: 36px;
  }
  /deep/.el-input__inner{
    padding-left: 90px;
  }
}
</style>
